require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-mining-infrastructure-investment-support-minis-project.json") })
        }
      }, "path---en-us-project-mining-infrastructure-investment-support-minis-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-mining-infrastructure-investment-support-minis-project!./.cache/json/en-us-project-mining-infrastructure-investment-support-minis-project.json
// module id = 542
// module chunks = 231608221292675